<template>
    <div class="flex-col relative">
        <input id="search" v-focus name="search" class="form-input-inline-w-none w-full" v-model="query" type="text" @keyup="search" />
        <div v-if="results.length > 0" class="absolute left-0 md:inset-auto w-full sm:min-w-sm md:min-w-md max-h-96 overflow-auto z-50 bg-white border mt-1 p-3 shadow-md rounded">
            <div :class="{ selected: index === selectedIndex }" v-for="(result, index) in results" :key="index">
                <a :href="getLink(result)" class="font-normal">
                    <slot :result="result">
                        {{ result.username }}
                    </slot>
                </a>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
    searchRoute: {
        type: String,
        required: true
    },
    linkRoute: {
        type: String,
        required: true
    },
    linkParameter: {
        type: String,
        required: true
    },
    linkParameterKey: {
        type: String,
        required: true
    },
});

const query = ref('');
const results = ref([]);
const selectedIndex = ref(0);

const search = async (event) => {
    const route = window.route(props.searchRoute);

    // if escape key
    if (event.keyCode === 27) {
        clearResults();
        return;
    }

    // up
    if (event.keyCode === 38) {
        selectedIndex.value = ((selectedIndex.value + results.value.length) - 1) % results.value.length;
        return;
    }

    // down
    if (event.keyCode === 40) {
        selectedIndex.value = (selectedIndex.value + 1) % results.value.length;
        return;
    }

    // enter
    if (event.keyCode === 13) {
        selectUser(results.value[selectedIndex.value]);
        return;
    }

    try {
        const response = await axios.post(route, { query: query.value });
        results.value = response.data;
    } catch (error) {
    }
};

const selectUser = (user) => {
    window.location = getLink(user);
};

const clearResults = () => {
    results.value = [];
};

const getLink = (item) => {
    const param = { [props.linkParameterKey]: item[props.linkParameter] };
    return window.route(props.linkRoute, param);
};
</script>

<style lang="scss">
.selected {
    background-color: #eff8ff;

    a {
        font-weight: 600;
    }
}
</style>
